import axios from 'axios'
import baseurl from './baseurl'
console.log(baseurl.dev)
export const request = (url,params)=>{
    return  axios.get(baseurl.dev+url,params)
}